import { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";
import { motion, useAnimation } from "framer-motion";

const Reveal = ({ children, classNamesOther }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.2 });
  const [scrollDirection, setScrollDirection] = useState("down");
  const [hasBeenVisible, setHasBeenVisible] = useState(false); // Track if the element has been visible
  const lastScrollY = useRef(window.scrollY);

  const mainControls = useAnimation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current) {
        setScrollDirection("down");
      } else if (currentScrollY < lastScrollY.current) {
        setScrollDirection("up");
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isInView && scrollDirection === "down") {
      mainControls.start("visible");
      setHasBeenVisible(true); // Mark the element as visible
    } else if (!isInView && scrollDirection === "up" && hasBeenVisible && (ref.current.offsetTop - 50) > window.scrollY) {
      // If scrolling up and the element has been visible before, keep it visible
      mainControls.start("hidden");
      setHasBeenVisible(false);
    } else if (!isInView && !hasBeenVisible) {
      // If the element has never been visible, reset to hidden
      mainControls.start("hidden");
    }
  }, [isInView, scrollDirection, mainControls, hasBeenVisible]);

  return (
    <div ref={ref} className={`relative overflow-hidden w-fit ${classNamesOther}`}>
      <motion.div
        variants={{
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={mainControls}
        transition={{ duration: 0.7, delay: 0.3 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default Reveal;